var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 26,
    viewBox: "0 0 224 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62676",
    "data-name": "Group 62676",
    transform: "translate(-86 -518.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16383",
    "data-name": "Rectangle 16383",
    transform: "translate(86 518.49)",
    fill: "#fff",
    stroke: "#d3d3d3",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 26,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 223.3,
    height: 25.3,
    rx: 0.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Privacy_Statement",
    "data-name": "Privacy Statement",
    transform: "translate(258 533)",
    fill: "#1072c6",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Privacy Statement")), /*#__PURE__*/React.createElement("text", {
    id: "Disclaimer",
    transform: "translate(243 533)",
    fill: "#1072c6",
    fontSize: 5,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.479,
    y: 0
  }, "Disclaimer")), /*#__PURE__*/React.createElement("text", {
    id: "Copyright_2020._The_Landmark_Trust_",
    "data-name": "Copyright 2020. The Landmark Trust\\u2026\\u2026 ",
    transform: "translate(92 534)",
    fill: "#3a3a3a",
    fontSize: 6,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Copyright 2020. The Landmark Trust\u2026\u2026 ")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter2);
export default __webpack_public_path__ + "static/media/footer2.93968682f543500bf8922bf7592d454d.svg";
export { ForwardRef as ReactComponent };